var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { DateRangePicker as BaseDateRangePicker } from 'react-date-range';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import format from 'date-fns/format';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // default css file
import Button from '../../../geebee/Button';
import TextInput from '../TextInput';
var DatePickerPopOverId = 'geebee-date-range-picker';
var DateRangePicker = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var splitInputView = _a.splitInputView, onChange = _a.onChange, range = _a.range, startDateTextInputProps = _a.startDateTextInputProps, endDateTextInputProps = _a.endDateTextInputProps, startAndEndDateTextInputProps = _a.startAndEndDateTextInputProps, reactDateRangePickerProps = _a.reactDateRangePickerProps;
    var _k = __read(React.useState(null), 2), anchorEl = _k[0], setAnchorEl = _k[1];
    var _l = __read(useState([
        {
            endDate: new Date(''),
            key: 'selection'
        }
    ]), 2), state = _l[0], setState = _l[1];
    useEffect(function () {
        if (!(range === null || range === void 0 ? void 0 : range.startDate)) {
            setState([
                {
                    endDate: new Date(''),
                    key: 'selection'
                }
            ]);
        }
        else {
            setState([__assign(__assign({}, range), { key: 'selection' })]);
        }
    }, [range]);
    var DateInput = splitInputView ? (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-pointer-events-none" },
        React.createElement(TextInput, __assign({ className: "lfc-mr-2", placeholder: "DD/MM/YYYY" }, startDateTextInputProps, { value: ((_b = state[0]) === null || _b === void 0 ? void 0 : _b.startDate) ? format((_c = state[0]) === null || _c === void 0 ? void 0 : _c.startDate, 'dd/MM/yyyy') : '' })),
        React.createElement(Divider, { style: { margin: '16px', borderColor: '#8E8E8E' }, className: " lfc-w-2 lfc-border lfc-border-black ", orientation: "horizontal" }),
        React.createElement(TextInput, __assign({ className: "lfc-ml-2", placeholder: "DD/MM/YYYY" }, endDateTextInputProps, { value: ((_d = state[0]) === null || _d === void 0 ? void 0 : _d.endDate) ? format((_e = state[0]) === null || _e === void 0 ? void 0 : _e.endDate, 'dd/MM/yyyy') : '' })))) : (React.createElement(TextInput, __assign({ placeholder: "DD/MM/YYYY - DD/MM/YYYY", className: "lfc-pointer-events-none" }, startAndEndDateTextInputProps, { value: ((_f = state[0]) === null || _f === void 0 ? void 0 : _f.startDate) && ((_g = state[0]) === null || _g === void 0 ? void 0 : _g.endDate)
            ? "".concat(format((_h = state[0]) === null || _h === void 0 ? void 0 : _h.startDate, 'dd/MM/yyyy'), " - ").concat(format((_j = state[0]) === null || _j === void 0 ? void 0 : _j.endDate, 'dd/MM/yyyy'), " ")
            : '' })));
    var handleInputWrapperClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    var handleDateChange = function (item) {
        var _a, _b;
        setState([item.selection]);
        onChange === null || onChange === void 0 ? void 0 : onChange({ startDate: (_a = item === null || item === void 0 ? void 0 : item.selection) === null || _a === void 0 ? void 0 : _a.startDate, endDate: (_b = item === null || item === void 0 ? void 0 : item.selection) === null || _b === void 0 ? void 0 : _b.endDate });
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? DatePickerPopOverId : undefined;
    return (React.createElement(Box, { sx: {} },
        React.createElement("div", { onClick: handleInputWrapperClick, className: "lfc-font-[500]" }, DateInput),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            } },
            React.createElement(BaseDateRangePicker, __assign({ onChange: handleDateChange, classNames: geebeeStyleClasses, ranges: state, weekdayDisplayFormat: "EEEEEE", inputRanges: [] }, reactDateRangePickerProps)),
            React.createElement("div", { className: "lfc-w-full lfc-flex lfc-items-center lfc-justify-end lfc-p-2" },
                React.createElement(Button, { variant: "text", onClick: function () {
                        setState([
                            {
                                endDate: new Date(''),
                                key: 'selection'
                            }
                        ]);
                        onChange === null || onChange === void 0 ? void 0 : onChange({
                            startDate: undefined,
                            endDate: undefined
                        });
                        setAnchorEl(null);
                    } }, "Clear Selection")))));
};
export default DateRangePicker;
var geebeeStyleClasses = {
    dateDisplayWrapper: 'lfc-hidden',
    nextPrevButton: 'lfc-bg-primary-100',
    monthAndYearWrapper: 'lfc-h-fit lfc-p-2',
    dayNumber: ' lfc-text-[0.875rem] lfc-font-[700]',
    startEdge: '[&~.rdrDayNumber]:lfc-bg-primary-500 [&~.rdrDayNumber]:lfc-rounded-full',
    endEdge: '[&~.rdrDayNumber]:lfc-bg-primary-500 [&~.rdrDayNumber]:lfc-rounded-full',
    day: 'lfc-h-[4.2em]  [&>.rdrInRange~.rdrDayNumber>span]:lfc-text-black [&>.rdrInRange~.rdrDayNumber>span]:lfc-font-light  [&>.rdrInRange]:lfc-bg-primary-200 [&>.rdrStartEdge]:lfc-bg-primary-200 [&>.rdrStartEdge]:lfc-rounded-l-full  [&>.rdrEndEdge]:lfc-bg-primary-200 [&>.rdrEndEdge]:lfc-rounded-r-full',
    dayStartPreview: 'lfc-border-primary-200',
    dayEndPreview: 'lfc-border-primary-200 ',
    dayInPreview: 'lfc-border-primary-200',
    monthAndYearPickers: 'lfc-text-[0.75rem] lfc-font-[500]',
    months: 'lfc-border-b',
    dateRangePickerWrapper: '[&>.rdrStaticRanges>.rdrStaticRangeSelected>.rdrStaticRangeLabel]:lfc-hidden [&>.rdrDefinedRangesWrapper]:lfc-w-[150px] [&>.rdrDefinedRangesWrapper]:lfc-text-[0.75rem] [&>.rdrDefinedRangesWrapper]:lfc-font-[500]'
};
//# sourceMappingURL=index.js.map